import { render } from "./PaymentTokenImage.vue?vue&type=template&id=1763472c&scoped=true"
import script from "./PaymentTokenImage.vue?vue&type=script&lang=js"
export * from "./PaymentTokenImage.vue?vue&type=script&lang=js"

import "./PaymentTokenImage.vue?vue&type=style&index=0&id=1763472c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1763472c"

export default script